import config from "../boot/config";
import http from "../boot/http.js";
import { DateTime } from "../utils";

const route = "RuleReport/"
const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default class {

    static GetReport(ruleInstanceId){
        let url = `${config.baseUrl + route}GetReport`;
        return http({url, method: 'GET', params: {ruleInstanceId: ruleInstanceId}})
        .then((data) => data)
        .catch((error) => error)
    }

    static GeneratePdf(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GeneratePdf`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error)
    }

    static GetPercentageOutsideRange(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GetPercentageOutsideRange`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error)
    }

    static GetTimeOutsideRange(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GetTimeOutsideRange`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error)
    }

    static GetRunTimesAndFailures(ruleInstanceId, fromDate, toDate, mustBeOutsideOffset = false){
		let url = `${config.baseUrl + route}GetRunTimesAndFailures`;
		let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat), mustBeOutsideOffset: mustBeOutsideOffset};
		return http({url, method: 'GET', params: params})
		.then((data) => data)
		.catch((error) => error)
  }

  static GetDerivedPastValues(ruleInstanceId, fromDate, toDate){
	let url = `${config.baseUrl + route}GetDerivedPastValues`;
	let params = {ruleInstanceId, fromDate, toDate};
	return http({url, method: 'GET', params: params})
	.then((data) => data)
	.catch((error) => error)
}

    static GetFailureOccurrences(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GetFailureOccurrences`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error) 
    }

    static GetHourlyFailures(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GetHourlyFailures`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error) 
    }

    static GetWeeklyFailures(ruleInstanceId, weeks){
		let url = `${config.baseUrl + route}GetWeeklyFailures`;
		let params = {ruleInstanceId:ruleInstanceId, weeks:weeks};
		return http({url, method: 'GET', params: params})
		.then((data) => data)
		.catch((error) => error) 
  }


  static GetDailyFailures(ruleInstanceId, fr, to){
    let url = `${config.baseUrl + route}GetDailyFailures`;
    
    var fromDate = DateTime.toISOstring(fr);
    var toDate = DateTime.toISOstring(to);

	return http({url, method: 'GET', ruleInstanceId, fromDate, toDate})
	.then((data) => data)
	.catch((error) => error) 
}

    static GetSampleSummary(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GetSampleSummary`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error)  
    }

    static GetDailyFailureSummary(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GetDailyFailureSummary`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error)  
    }

    static RuleInstanceReportTypeAhead(searchTerm){
        let url = `${config.baseUrl + route}RuleInstanceReportTypeAhead`;
        let params = {searchTerm:searchTerm};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error) 
    }

    //NOTE: only gets a summaried version of rule instance because no need to load all the data.
    static GetBasicRuleInstance(ruleInstanceId){
        let url = `${config.baseUrl + route}GetBasicRuleInstance`;
        let params = {ruleInstanceId:ruleInstanceId};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error) 
    }

    static GetRuleInstances(siteName, searchTerm) {
        let url = `${config.baseUrl + route}GetRuleInstances`;
        let params = { siteName: siteName, searchTerm:searchTerm };
        return http({ url, method: 'GET', params: params})
            .then((data) => data)
            .catch((error) => error)
    }

    static GetUpperLimit(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GetUpperLimit`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error)  
    }

    static GetLowerLimit(ruleInstanceId, fromDate, toDate){
        let url = `${config.baseUrl + route}GetLowerLimit`;
        let params = {ruleInstanceId:ruleInstanceId, fromDate:fromDate.format(dateFormat), toDate:toDate.format(dateFormat)};
        return http({url, method: 'GET', params: params})
        .then((data) => data)
        .catch((error) => error)  
    }
}



// WEBPACK FOOTER //
// ./src/services/reports.js